import React, { useState } from 'react';
import AdminDashboard from './AdminDashboard';
import AdminOrders from './AdminOrders';
import AdminProducts from './AdminProducts';
import AdminUsers from './AdminUsers';
import AdminCreateBill from './AdminCreateBill';
import AdminSales from './AdminSales';

const AdminView = ({ isAuthenticated, showMessage, userRole }) => {
    const [activeTab, setActiveTab] = useState('dashboard');

    if (!isAuthenticated) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[60vh]">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-6">
                    <i className="fas fa-lock text-3xl text-red-500"></i>
                </div>
                <h2 className="text-3xl font-extrabold text-slate-800 mb-2">Access Denied</h2>
                <p className="text-slate-500">Please log in as an administrator to view this page.</p>
            </div>
        );
    }

    const tabs = [
        { id: 'dashboard', label: 'Overview', icon: 'fa-chart-pie' },
        { id: 'create-bill', label: 'Create Bill', icon: 'fa-file-invoice' },
        { id: 'sales', label: 'Sales Report', icon: 'fa-chart-line' },
        { id: 'orders', label: 'Orders', icon: 'fa-box-open' },
        { id: 'products', label: 'Inventory', icon: 'fa-pills' },
        { id: 'users', label: 'Customers', icon: 'fa-users' },
    ];

    return (
        <div className="flex flex-col min-h-[88vh] gap-3 sm:gap-6 p-2 sm:p-4 max-w-[1400px] mx-auto w-full">
            {/* Top Navigation Bar */}
            <header className="w-full bg-white rounded-2xl md:rounded-3xl shadow-md md:shadow-xl border border-slate-100 p-3 sm:p-4 md:px-6 md:py-4 h-fit shrink-0 flex flex-col md:flex-row items-center justify-between gap-4">
                {/* Header Badge */}
                <div className="flex items-center w-full md:w-auto justify-between md:justify-start gap-3">
                    <div className="flex items-center gap-2.5">
                        <div className="w-9 h-9 md:w-12 md:h-12 bg-sky-500 rounded-xl flex items-center justify-center shadow-md shadow-sky-500/25 shrink-0">
                            <i className="fas fa-shield-alt text-white text-base md:text-xl"></i>
                        </div>
                        <div>
                            <h2 className="text-sm md:text-lg font-black text-slate-800 tracking-tight leading-tight">Admin Center</h2>
                            <p className="text-[10px] md:text-xs text-slate-400 font-medium">QwickMed Pharmacy</p>
                        </div>
                    </div>
                </div>

                {/* Navigation: Horizontal scroll on all devices */}
                <nav className="flex flex-row gap-1.5 md:gap-2 overflow-x-auto w-full md:w-auto pb-1 md:pb-0 scrollbar-none -mx-1 px-1">
                    {tabs.map(tab => {
                        const isActive = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`flex items-center gap-2 md:gap-2 px-3 md:px-4 py-2 md:py-2.5 rounded-xl md:rounded-xl transition-all duration-200 font-bold text-xs md:text-sm whitespace-nowrap shrink-0 ${
                                    isActive
                                        ? 'bg-sky-500 text-white shadow-md shadow-sky-500/20'
                                        : 'text-slate-600 hover:bg-slate-50 hover:text-sky-600 bg-slate-50/70 md:bg-transparent'
                                }`}
                            >
                                <i className={`fas ${tab.icon} w-4 text-center text-xs md:text-sm ${isActive ? 'opacity-100' : 'opacity-70'}`}></i>
                                <span>{tab.label}</span>
                            </button>
                        );
                    })}
                </nav>
            </header>

            {/* Main Content Area */}
            <main className="flex-grow bg-white rounded-2xl md:rounded-3xl shadow-md md:shadow-xl border border-slate-100 p-3 sm:p-5 md:p-8 overflow-hidden min-w-0">
                <div className="h-full relative">
                    {activeTab === 'dashboard' && <AdminDashboard showMessage={showMessage} />}
                    {activeTab === 'create-bill' && <AdminCreateBill showMessage={showMessage} />}
                    {activeTab === 'sales' && <AdminSales showMessage={showMessage} />}
                    {activeTab === 'orders' && <AdminOrders showMessage={showMessage} />}
                    {activeTab === 'products' && <AdminProducts showMessage={showMessage} />}
                    {activeTab === 'users' && <AdminUsers showMessage={showMessage} userRole={userRole} />}
                </div>
            </main>
        </div>
    );
};

export default AdminView;
